import axios from '@axios';

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		fetchCompetitionReview(ctx, { id }) {
			return new Promise((resolve, reject) => {
				axios
					.get(`/competition-reviews/${id}/edit`)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
	}
}